<template>
  <component :is="item.value instanceof Object ? 'div' : 'span'">
    <template v-if="item.value instanceof Object && item.value.template">
      <div><h6>{{ item.key }}</h6></div>
      <component :is="item.value" v-bind="item"></component>
    </template>
    <template v-else>
      <div><h6>{{ item.key }}</h6></div>
      <span>{{ item.value }}</span>
    </template>
  </component>
</template>

<script>
  export default {
    props: {
      item: Object
    }
  }
</script>
